import { render } from "./NavDropdown.vue?vue&type=template&id=d9909970&scoped=true"
import script from "./NavDropdown.vue?vue&type=script&lang=js"
export * from "./NavDropdown.vue?vue&type=script&lang=js"

import "./NavDropdown.vue?vue&type=style&index=0&id=d9909970&scoped=true&lang=css"

import exportComponent from "/home/admin/domains/web3.owatts.io/public_html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9909970"]])

export default __exports__